import { render, staticRenderFns } from "./LayoutHeaderUserData.vue?vue&type=template&id=0a615e54&scoped=true&lang=pug"
import script from "./LayoutHeaderUserData.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderUserData.vue?vue&type=script&lang=js"
import style0 from "./LayoutHeaderUserData.vue?vue&type=style&index=0&id=0a615e54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a615e54",
  null
  
)

export default component.exports